export const envBaseUrlApi =
  import.meta.env.APP_BASE_API_URL || "https://hh-engineering.my.id/api/partner/v1/";
export const envBaseUrlApiRestaurant =
  import.meta.env.APP_BASE_API_RESTAURANT_URL || "https://hh-engineering.my.id/api/v5/restaurants/";
export const envBaseUrlApiPriceEngine =
  import.meta.env.APP_BASE_API_PRICE_ENGINE_URL ||
  "https://price-engine.hh-engineering.my.id/api/partner/v1/";
export const envHHMenuApiUrl =
  import.meta.env.APP_HH_MENU_API_URL || "https://menu.hh-engineering.my.id/api/v1/";
export const envChartUrl =
  import.meta.env.APP_CHART_URL || "https://charts.mongodb.com/charts-hungryhub-staging-fcqfi";

export const ENV_OPTIONS = [
  {
    label: "Use Env",
    value: {
      envKey: "env",
      baseApiUrl: envBaseUrlApi,
      baseApiRestaurantUrl: envBaseUrlApiRestaurant,
      baseApiPriceEngineUrl: envBaseUrlApiPriceEngine,
      hhMenuApiUrl: envHHMenuApiUrl,
      chartUrl: envChartUrl,
    },
  },
  {
    label: "Use Engineering",
    value: {
      envKey: "engineering",
      baseApiUrl: "https://hh-engineering.my.id/api/partner/v1/",
      baseApiRestaurantUrl: "https://hh-engineering.my.id/api/v5/restaurants/",
      baseApiPriceEngineUrl: "https://price-engine.hh-engineering.my.id/api/partner/v1/",
      hhMenuApiUrl: "https://menu.hh-engineering.my.id/api/v1/",
      chartUrl: "https://charts.mongodb.com/charts-hungryhub-staging-fcqfi",
    },
  },
  {
    label: "Use Ballbot",
    value: {
      envKey: "ballbot",
      baseApiUrl: "https://hh-ballbot.my.id/api/partner/v1/",
      baseApiRestaurantUrl: "https://hh-ballbot.my.id/api/v5/restaurants/",
      baseApiPriceEngineUrl: "https://price-engine.hh-engineering.my.id/api/partner/v1/",
      hhMenuApiUrl: "https://menu.hh-engineering.my.id/api/v1/",
      chartUrl: "https://charts.mongodb.com/charts-hungryhub-staging-fcqfi",
    },
  },
  {
    label: "Use Venus",
    value: {
      envKey: "venus",
      baseApiUrl: "https://hh-venus.my.id/api/partner/v1/",
      baseApiRestaurantUrl: "https://hh-venus.my.id/api/v5/restaurants/",
      baseApiPriceEngineUrl: "https://price-engine.hh-engineering.my.id/api/partner/v1/",
      hhMenuApiUrl: "https://menu.hh-engineering.my.id/api/v1/",
      chartUrl: "https://charts.mongodb.com/charts-hungryhub-staging-fcqfi",
    },
  },
  {
    label: "Use Production",
    value: {
      envKey: "production",
      baseApiUrl: "https://partners-api.hungryhub.com/api/partner/v1/",
      baseApiRestaurantUrl: "https://hungryhub.com/api/v5/restaurants/",
      baseApiPriceEngineUrl: "https://pricing-engine-prod.hungryhub.com/api/partner/v1/",
      hhMenuApiUrl: "https://menu.hungryhub.com/api/",
      chartUrl: "https://charts.mongodb.com/charts-hungryhub-production-eoxjz",
    },
  },
  {
    label: "Use Custom",
    value: {
      envKey: "custom",
      baseApiUrl: "",
      baseApiRestaurantUrl: "",
      baseApiPriceEngineUrl: "",
      hhMenuApiUrl: "",
      chartUrl: "",
    },
  },
];
